export default __webpack_public_path__ + "static/media/newsSummerNights.caf1a610.jpg";